
import { Component, Vue } from "vue-property-decorator";
import Sidebar from "@/components/navigations/Sidebar.vue";
import CardProchaineActivite from "@/components/card/CardProchaineActivite.vue";
import panelActivite from "@/components/panel/PanelActivite.vue";

/** "Uniformes" page — currently a static placeholder, no data wired in (counts are hardcoded "-"). */
@Component({
  components: {
    Sidebar,
    CardProchaineActivite,
    panelActivite,
  },
})
export default class LocalTenues extends Vue {}
